/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        AgentVariableDistribution200ResponseInner,
        ScrimGames,
        ScrimGamesAggregate,
    } from '../models/index';

            export interface ScrimGamesAggregateRequest {
                groupby: Array<string>;
                ordering: Array<string>;
                additional_filters?: object;
                aggregates?: Array<string>;
                having?: object;
                id?: string;
                index_on?: string;
                map?: string;
                metrics?: Array<string>;
                team1?: string;
                team2?: string;
                winner?: string;
            }

            export interface ScrimGamesFieldValuesRequest {
                field: string;
                ordering: Array<string>;
                additional_filters?: object;
                id?: string;
                map?: string;
                team1?: string;
                team2?: string;
                winner?: string;
            }

            export interface ScrimGamesGetRequest {
                id: string;
            }

            export interface ScrimGamesListRequest {
                additional_filters?: object;
                annotations?: Array<string>;
                id?: string;
                map?: string;
                only_values?: Array<string>;
                ordering?: Array<string>;
                team1?: string;
                team2?: string;
                winner?: string;
            }

            export interface ScrimGamesVariableDistributionRequest {
                bucket_size: number;
                max: number;
                metric: string;
                min: number;
                additional_filters?: object;
                id?: string;
                map?: string;
                team1?: string;
                team2?: string;
                winner?: string;
            }

        /**
        * 
        */
            export class ScrimGamesApi extends runtime.BaseAPI {

            /**
            */
            async scrimGamesAggregateRaw(requestParameters: ScrimGamesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ScrimGamesAggregate>>> {
                    if (requestParameters.groupby === null || requestParameters.groupby === undefined) {
                    throw new runtime.RequiredError('groupby','Required parameter requestParameters.groupby was null or undefined when calling scrimGamesAggregate.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling scrimGamesAggregate.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.aggregates) {
                        queryParameters['aggregates'] = requestParameters.aggregates;
                    }

                    if (requestParameters.groupby) {
                        queryParameters['groupby'] = requestParameters.groupby;
                    }

                    if (requestParameters.having !== undefined) {
                            queryParameters['having'] = requestParameters.having;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.index_on !== undefined) {
                            queryParameters['index_on'] = requestParameters.index_on;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.metrics) {
                        queryParameters['metrics'] = requestParameters.metrics;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.winner !== undefined) {
                            queryParameters['winner'] = requestParameters.winner;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/ScrimGames/operations/aggregate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async aggregate(requestParameters: ScrimGamesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ScrimGamesAggregate>> {
                    const response = await this.scrimGamesAggregateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async scrimGamesFieldValuesRaw(requestParameters: ScrimGamesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
                    if (requestParameters.field === null || requestParameters.field === undefined) {
                    throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling scrimGamesFieldValues.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling scrimGamesFieldValues.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.field !== undefined) {
                            queryParameters['field'] = requestParameters.field;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.winner !== undefined) {
                            queryParameters['winner'] = requestParameters.winner;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/ScrimGames/operations/field-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse<any>(response);
            }

            /**
            */
                async field_values(requestParameters: ScrimGamesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
                    const response = await this.scrimGamesFieldValuesRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async scrimGamesGetRaw(requestParameters: ScrimGamesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScrimGames>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling scrimGamesGet.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/ScrimGames/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async get(requestParameters: ScrimGamesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScrimGames> {
                    const response = await this.scrimGamesGetRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async scrimGamesListRaw(requestParameters: ScrimGamesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ScrimGames>>> {
            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.annotations) {
                        queryParameters['annotations'] = requestParameters.annotations;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.only_values) {
                        queryParameters['only_values'] = requestParameters.only_values;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.winner !== undefined) {
                            queryParameters['winner'] = requestParameters.winner;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/ScrimGames/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async list(requestParameters: ScrimGamesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ScrimGames>> {
                    const response = await this.scrimGamesListRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async scrimGamesVariableDistributionRaw(requestParameters: ScrimGamesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AgentVariableDistribution200ResponseInner>>> {
                    if (requestParameters.bucket_size === null || requestParameters.bucket_size === undefined) {
                    throw new runtime.RequiredError('bucket_size','Required parameter requestParameters.bucket_size was null or undefined when calling scrimGamesVariableDistribution.');
                    }

                    if (requestParameters.max === null || requestParameters.max === undefined) {
                    throw new runtime.RequiredError('max','Required parameter requestParameters.max was null or undefined when calling scrimGamesVariableDistribution.');
                    }

                    if (requestParameters.metric === null || requestParameters.metric === undefined) {
                    throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling scrimGamesVariableDistribution.');
                    }

                    if (requestParameters.min === null || requestParameters.min === undefined) {
                    throw new runtime.RequiredError('min','Required parameter requestParameters.min was null or undefined when calling scrimGamesVariableDistribution.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.bucket_size !== undefined) {
                            queryParameters['bucket_size'] = requestParameters.bucket_size;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.max !== undefined) {
                            queryParameters['max'] = requestParameters.max;
                    }

                    if (requestParameters.metric !== undefined) {
                            queryParameters['metric'] = requestParameters.metric;
                    }

                    if (requestParameters.min !== undefined) {
                            queryParameters['min'] = requestParameters.min;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.winner !== undefined) {
                            queryParameters['winner'] = requestParameters.winner;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/ScrimGames/operations/variable-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async variable_distribution(requestParameters: ScrimGamesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AgentVariableDistribution200ResponseInner>> {
                    const response = await this.scrimGamesVariableDistributionRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }
